var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"link",class:_vm.classes,attrs:{"href":_vm.href,"target":_vm.hasTarget,"rel":_vm.hasRel},on:{"click":function($event){return _vm.handleClick($event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }